module.exports = __webpack_public_path__ + "assets/achievement.e3c0ef09.svg";